'use strict';

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var protons = require('protons');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var pb = protons(require('./record.proto')).Record;

var utils = require('./utils');

var Record = /*#__PURE__*/function () {
  /**
   * @param {Buffer} [key]
   * @param {Buffer} [value]
   * @param {Date} [recvtime]
   */
  function Record(key, value, recvtime) {
    _classCallCheck(this, Record);

    if (key && !Buffer.isBuffer(key)) {
      throw new Error('key must be a Buffer');
    }

    if (value && !Buffer.isBuffer(value)) {
      throw new Error('value must be a buffer');
    }

    this.key = key;
    this.value = value;
    this.timeReceived = recvtime;
  }
  /**
   * @returns {Buffer}
   */


  _createClass(Record, [{
    key: "serialize",
    value: function serialize() {
      return pb.encode(this.prepareSerialize());
    }
    /**
     * Return the object format ready to be given to the protobuf library.
     *
     * @returns {Object}
     */

  }, {
    key: "prepareSerialize",
    value: function prepareSerialize() {
      return {
        key: this.key,
        value: this.value,
        timeReceived: this.timeReceived && utils.toRFC3339(this.timeReceived)
      };
    }
    /**
     * Decode a protobuf encoded record.
     *
     * @param {Buffer} raw
     * @returns {Record}
     */

  }], [{
    key: "deserialize",
    value: function deserialize(raw) {
      var dec = pb.decode(raw);
      return Record.fromDeserialized(dec);
    }
    /**
     * Create a record from the raw object returned from the protobuf library.
     *
     * @param {Object} obj
     * @returns {Record}
     */

  }, {
    key: "fromDeserialized",
    value: function fromDeserialized(obj) {
      var recvtime;

      if (obj.timeReceived) {
        recvtime = utils.parseRFC3339(obj.timeReceived);
      }

      var rec = new Record(obj.key, obj.value, recvtime);
      return rec;
    }
  }]);

  return Record;
}();

module.exports = Record;